/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import classnames from 'classnames';

export function ColorSwatch({
  className,
  color,
  isMuted,
}: {
  className?: string;
  color: string;
  isMuted?: boolean;
}) {
  return (
    <span
      className={classnames(
        className,
        'inline-block size-5 rounded border-2 border-primary',
      )}
      css={css`
        background-color: rgb(${color} / ${isMuted ? 0.2 : 0.6});
      `}
    />
  );
}
